import { action } from 'satcheljs';
import { getDefaultLogonEmailAddress } from 'owa-session-store';

/**
 * Action to get shared folders for a particular user.
 * @param sharedUserMailboxSmtpAddress The mailbox identifier for mailbox from where the shared folders will be fetched.
 * @param actionSource Source from where this action is called.
 * @param isLoadingMore indicates if service is loading more
 * @param userIdentity indicates the current user identity for whom the shared folders will be fetched
 *
 */
export const getSharedFolders = action(
    'GET_SHARED_FOLDERS',
    (
        sharedUserMailboxSmtpAddress: string,
        actionSource: string,
        isLoadingMore?: boolean,
        userIdentity?: string
    ) => {
        if (!userIdentity) {
            userIdentity = getDefaultLogonEmailAddress();
        }
        return {
            sharedUserMailboxSmtpAddress,
            actionSource,
            isLoadingMore,
            userIdentity,
        };
    }
);
